import React from "react";
import { useSelector } from "react-redux";
import style from "./CustomerDetails.module.scss";

const CustomerDetails = () => {
  const role = useSelector((state) => state.user?.role);
  const customerData = useSelector((state) => state.customer.detailViewData);

  return (
    <>
      {role === "MedlineAdministrator" ? (
        <span>
          Customers
          <pre className={style.customer_details}>
            <p>
              {customerData?.customerNumber} | {customerData?.customerName}
            </p>{" "}
          </pre>
          <pre className={`mt-0 ${style.customer_details}`}>
            <p>
              {customerData?.address?.addressLine1 ? customerData?.address?.addressLine1 + "," : ""}{" "}
              {customerData?.address?.city ? customerData?.address?.city + ", " : ""}{" "}
              {customerData?.address?.state ? customerData?.address?.state + ", " : ""}{" "}
              {customerData?.address?.country ? customerData?.address?.country : ""}
              {customerData?.address?.zipCode ? ", " + customerData?.address?.zipCode : ""}
            </p>
          </pre>
        </span>
      ) : role === "ExternalAdministrator" ? (
        "Company Profile"
      ) : (
        ""
      )}
    </>
  );
};

export default CustomerDetails;
